/* ════════════════════════════════════════════════════════════════
   Peach Up — Search Modal JS (Sub-Fase 1C + 1D antecipado)
   - Dropdown abaixo do header (não-fullscreen)
   - Event capture interception (sem brigar com details-modal antigo)
   - Live search via /search/suggest.json
   - AbortController + token check (race conditions)
   - Cache LRU 50 entries
   - Timeout 5s
   - Posicionamento dinâmico via getBoundingClientRect
   ════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    var root = document.getElementById('peach-search-modal-root');
    if (!root) return; // Section desativada

    var modal     = root.querySelector('[data-peach-search-modal]');
    var input     = root.querySelector('[data-peach-search-input]');
    var closeBtn  = root.querySelector('[data-peach-search-close]');
    var content   = root.querySelector('[data-peach-search-content]');
    var titleEl   = root.querySelector('[data-peach-search-title]');
    var resultsEl = root.querySelector('[data-peach-search-results]');

    if (!modal || !input || !closeBtn || !content || !titleEl || !resultsEl) return;

    // ──────────────────────────────────────────────────────────
    // CONFIG
    // ──────────────────────────────────────────────────────────
    var SEARCH_LIMIT = 6;
    var DEBOUNCE_MS = 300;
    var FETCH_TIMEOUT_MS = 5000;
    var MAX_CACHE_SIZE = 50;
    var IMAGE_WIDTH = 400;
    var MOBILE_BREAKPOINT = 768;

    var defaultSectionTitle = (titleEl.textContent || 'Produtos Sugeridos').trim();
    var headerSelector = root.getAttribute('data-header-selector') || '.section-header, sticky-header';

    // State
    var searchTimer = null;
    var currentController = null;
    var currentSearchToken = 0;
    var cache = new Map();
    var outsideClickAttached = false;
    var scrollListenerAttached = false;
    var rafId = null;
    var scrollLockY = null;

    // ──────────────────────────────────────────────────────────
    // PRODUTOS SUGERIDOS (lidos do DOM via data-*)
    // ──────────────────────────────────────────────────────────
    var suggestedProducts = [];
    var productNodes = root.querySelectorAll('[data-peach-search-product]');
    for (var i = 0; i < productNodes.length; i++) {
      var n = productNodes[i];
      suggestedProducts.push({
        name: n.getAttribute('data-name') || '',
        description: n.getAttribute('data-description') || '',
        price: n.getAttribute('data-price') || '',
        image: n.getAttribute('data-image') || '',
        url: n.getAttribute('data-url') || '#'
      });
    }

    // ──────────────────────────────────────────────────────────
    // UTILS
    // ──────────────────────────────────────────────────────────
    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str == null ? '' : String(str);
      return div.innerHTML;
    }

    function formatPriceFromShopify(price) {
      if (price == null || price === '') return '';
      var num = typeof price === 'string' ? parseFloat(price) : price;
      if (isNaN(num)) return '';
      // Shopify API retorna em centavos quando é um inteiro grande
      var value = num > 1000 ? num / 100 : num;
      return 'R$ ' + value.toFixed(2)
        .replace('.', ',')
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    function addImageSize(url, width) {
      if (!url) return '';
      // Shopify CDN aceita ?width=N pra transformação
      if (url.indexOf('?') === -1) {
        return url + '?width=' + width;
      }
      // Já tem query string — não mexe
      return url;
    }

    function mapApiProduct(p) {
      var image = '';
      if (p.featured_image && p.featured_image.url) {
        image = p.featured_image.url;
      } else if (p.image) {
        image = p.image;
      }
      image = addImageSize(image, IMAGE_WIDTH);

      var description = '';
      if (p.vendor) description = p.vendor;
      else if (p.product_type) description = p.product_type;

      return {
        name: p.title || '',
        description: description,
        price: formatPriceFromShopify(p.price),
        image: image,
        url: p.url || '#'
      };
    }

    // ──────────────────────────────────────────────────────────
    // RENDER
    // ──────────────────────────────────────────────────────────
    function renderLoading() {
      var cards = '';
      for (var i = 0; i < SEARCH_LIMIT; i++) {
        cards +=
          '<div class="peach-search-modal__loading-card">' +
            '<div class="peach-search-modal__loading-img"></div>' +
            '<div class="peach-search-modal__loading-line"></div>' +
            '<div class="peach-search-modal__loading-line peach-search-modal__loading-line--short"></div>' +
          '</div>';
      }
      return '<div class="peach-search-modal__loading">' + cards + '</div>';
    }

    function renderEmpty() {
      return (
        '<div class="peach-search-modal__empty">' +
          '<div class="peach-search-modal__empty-icon" aria-hidden="true">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
              '<circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>' +
            '</svg>' +
          '</div>' +
          '<h3 class="peach-search-modal__empty-title">Nenhum produto encontrado</h3>' +
          '<p class="peach-search-modal__empty-text">Tente buscar com outras palavras-chave</p>' +
        '</div>'
      );
    }

    function renderError() {
      return (
        '<div class="peach-search-modal__error">' +
          'Não foi possível buscar agora. Tente novamente em instantes.' +
        '</div>'
      );
    }

    function renderProducts(products) {
      if (!products || products.length === 0) return renderEmpty();
      var html = '<div class="peach-search-modal__grid">';
      for (var j = 0; j < products.length; j++) {
        var p = products[j];
        html +=
          '<a href="' + escapeHtml(p.url) + '" class="peach-product-card">' +
            '<div class="peach-product-card__image-wrap">' +
              (p.image
                ? '<img class="peach-product-card__image" src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.name) + '" loading="lazy" />'
                : '') +
            '</div>' +
            '<div class="peach-product-card__body">' +
              '<h4 class="peach-product-card__name">' + escapeHtml(p.name) + '</h4>' +
              (p.description ? '<p class="peach-product-card__desc">' + escapeHtml(p.description) + '</p>' : '') +
              (p.price ? '<p class="peach-product-card__price">' + escapeHtml(p.price) + '</p>' : '') +
            '</div>' +
          '</a>';
      }
      html += '</div>';
      return html;
    }

    // ──────────────────────────────────────────────────────────
    // LIVE SEARCH via Shopify API
    // ──────────────────────────────────────────────────────────
    function fetchSearch(query) {
      var cacheKey = query.toLowerCase().trim();

      // Cache hit?
      if (cache.has(cacheKey)) {
        return Promise.resolve(cache.get(cacheKey));
      }

      // Cancela request anterior
      if (currentController) {
        try { currentController.abort(); } catch (e) { /* noop */ }
      }
      currentController = new AbortController();

      // Timeout
      var timeoutId = setTimeout(function () {
        if (currentController) {
          try { currentController.abort(); } catch (e) { /* noop */ }
        }
      }, FETCH_TIMEOUT_MS);

      var url = '/search/suggest.json'
        + '?q=' + encodeURIComponent(query)
        + '&resources[type]=product'
        + '&resources[limit]=' + SEARCH_LIMIT
        + '&resources[options][unavailable_products]=last'
        + '&resources[options][fields]=title,product_type,variants.title,vendor';

      return fetch(url, { signal: currentController.signal })
        .then(function (r) {
          clearTimeout(timeoutId);
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          var mapped = [];
          for (var i = 0; i < products.length && i < SEARCH_LIMIT; i++) {
            mapped.push(mapApiProduct(products[i]));
          }
          // Cache LRU simples (Map preserva ordem de inserção)
          if (cache.size >= MAX_CACHE_SIZE) {
            cache.delete(cache.keys().next().value);
          }
          cache.set(cacheKey, mapped);
          return mapped;
        });
    }

    function performSearch(query) {
      var token = ++currentSearchToken;

      titleEl.textContent = 'Buscando...';
      resultsEl.innerHTML = renderLoading();

      fetchSearch(query)
        .then(function (results) {
          if (token !== currentSearchToken) return; // outra busca veio depois
          titleEl.textContent = 'Resultados da Busca';
          resultsEl.innerHTML = results.length === 0 ? renderEmpty() : renderProducts(results);
        })
        .catch(function (err) {
          // AbortError é silencioso (cancelamento intencional)
          if (err && err.name === 'AbortError') return;
          if (token !== currentSearchToken) return;
          titleEl.textContent = 'Resultados da Busca';
          resultsEl.innerHTML = renderError();
        });
    }

    function showSuggested() {
      // Cancela busca pendente
      currentSearchToken++;
      if (currentController) {
        try { currentController.abort(); } catch (e) { /* noop */ }
        currentController = null;
      }
      clearTimeout(searchTimer);
      titleEl.textContent = defaultSectionTitle;
      resultsEl.innerHTML = renderProducts(suggestedProducts);
    }

    // ──────────────────────────────────────────────────────────
    // POSICIONAMENTO DINÂMICO
    // ──────────────────────────────────────────────────────────
    function calculatePosition() {
      var headerEl = document.querySelector(headerSelector);
      var top = 72; // fallback
      if (headerEl) {
        var rect = headerEl.getBoundingClientRect();
        top = Math.max(0, rect.bottom + 8);
      }
      root.style.setProperty('--peach-search-top', top + 'px');
    }

    function onScrollOrResize() {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function () {
        calculatePosition();
        handleViewportChange();
      });
    }

    function attachPositionListeners() {
      if (scrollListenerAttached) return;
      window.addEventListener('scroll', onScrollOrResize, { passive: true });
      window.addEventListener('resize', onScrollOrResize, { passive: true });
      scrollListenerAttached = true;
    }
    function detachPositionListeners() {
      if (!scrollListenerAttached) return;
      window.removeEventListener('scroll', onScrollOrResize);
      window.removeEventListener('resize', onScrollOrResize);
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
      scrollListenerAttached = false;
    }

    // ──────────────────────────────────────────────────────────
    // SCROLL LOCK — APENAS MOBILE (técnica position:fixed do Plan B)
    // Evita o bug do iOS Safari com overflow:hidden no body.
    // ──────────────────────────────────────────────────────────
    function lockBodyScrollMobile() {
      if (window.innerWidth >= MOBILE_BREAKPOINT) return;
      if (scrollLockY !== null) return; // já travado
      scrollLockY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollLockY + 'px';
      document.body.style.width = '100%';
      document.body.dataset.peachScrollLock = String(scrollLockY);
    }

    function unlockBodyScrollMobile() {
      if (scrollLockY === null) return; // não estava travado
      var y = scrollLockY;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      delete document.body.dataset.peachScrollLock;
      scrollLockY = null;
      window.scrollTo(0, y);
    }

    // Rotação / resize com modal aberto: aplica/remove o lock conforme breakpoint
    function handleViewportChange() {
      if (!isOpen()) return;
      if (window.innerWidth >= MOBILE_BREAKPOINT) {
        unlockBodyScrollMobile();
      } else {
        lockBodyScrollMobile();
      }
    }

    // ──────────────────────────────────────────────────────────
    // CLICK FORA
    // ──────────────────────────────────────────────────────────
    function handleOutsideClick(e) {
      if (modal.contains(e.target)) return;
      if (e.target.closest && e.target.closest('summary.header__icon--search')) return;
      close();
    }

    // ──────────────────────────────────────────────────────────
    // OPEN / CLOSE
    // ──────────────────────────────────────────────────────────
    function open() {
      calculatePosition();
      modal.hidden = false;
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });
      attachPositionListeners();
      lockBodyScrollMobile();

      setTimeout(function () {
        try { input.focus(); } catch (e) {}
      }, 60);

      // Listener de click fora após o frame atual
      if (!outsideClickAttached) {
        requestAnimationFrame(function () {
          document.addEventListener('click', handleOutsideClick);
          outsideClickAttached = true;
        });
      }
    }

    function close() {
      modal.classList.remove('is-open');
      input.value = '';
      showSuggested();
      setTimeout(function () {
        modal.hidden = true;
      }, 220);
      detachPositionListeners();
      unlockBodyScrollMobile();
      if (outsideClickAttached) {
        document.removeEventListener('click', handleOutsideClick);
        outsideClickAttached = false;
      }
    }

    function isOpen() {
      return modal.classList.contains('is-open');
    }

    // ──────────────────────────────────────────────────────────
    // INTERCEPTAÇÃO DA LUPA DO SHRINE (event capture)
    // ──────────────────────────────────────────────────────────
    function searchInterceptor(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (isOpen()) {
        close();
      } else {
        open();
      }
    }

    var searchSummaries = document.querySelectorAll('summary.header__icon--search');
    for (var k = 0; k < searchSummaries.length; k++) {
      searchSummaries[k].addEventListener('click', searchInterceptor, { capture: true });
      searchSummaries[k].setAttribute('aria-controls', 'peach-search-modal-root');
    }

    // ──────────────────────────────────────────────────────────
    // INTERNOS
    // ──────────────────────────────────────────────────────────
    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      close();
    });

    // Click dentro do conteúdo não propaga pro document (evita fechar)
    content.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    // ESC
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) close();
    });

    // Input
    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(searchTimer);

      if (query.length === 0) {
        showSuggested();
        return;
      }

      // Feedback imediato (antes do debounce)
      titleEl.textContent = 'Buscando...';
      resultsEl.innerHTML = renderLoading();

      searchTimer = setTimeout(function () {
        performSearch(query);
      }, DEBOUNCE_MS);
    });

    // Init
    showSuggested();
  });
})();
